import { useEffect, useState } from 'react'
import { FaEdit } from "react-icons/fa"
import { BsFillPlayFill } from "react-icons/bs"
import { HiOutlineDocumentReport } from "react-icons/hi"

import { FullScreen, useFullScreenHandle } from "react-full-screen"
import { Carousel } from 'react-responsive-carousel'
import { PowerBIEmbed } from 'powerbi-client-react'
import { models } from 'powerbi-client'

import TitleBar from 'components/TitleBar'
import Content from 'components/Content'
import Card from 'components/Card'
import CardTitle from 'components/CardTitle'
import Table from 'components/Table'
import LinkBlue from 'components/Button/LinkBlue'
import SmLinkBlue from 'components/Button/SmLinkBlue'
import BtnOrange from 'components/Button/BtnOrange'
import LoadingScreen from 'components/LoadingScreen'

import Td from 'components/Td'

import api from 'services/api/api'
import { handlePowerBiReportAad } from 'services/api/powerbi'

import { ItemContainer } from './styled'

import "react-responsive-carousel/lib/styles/carousel.min.css"

export default function Carousels() {
    const [carousels, setCarousels] = useState([])
    const [data, setData] = useState([])

    const [reports, setReports] = useState([])
    
    const [isLoading, setIsLoading] = useState(false)
    const [isLoaded, setIsLoaded] = useState(false)
    const [showCarousel, setShowCarousel] = useState(false)
    const [intervalz, setIntervalz] = useState(5000)

    const [intervalx, setIntervalx] = useState(null)

    const handle = useFullScreenHandle()

    const getCarouselReports = async (id) => {
        const response = await api.get(`/carousels/${id}/reports/powerbi`)

        return response.data.map(item => ({
            reportId: item.report.report_id,
            embedUrl: item.powerbi.embedUrl,
            token: item.powerbi.accessToken,
            type: models.TokenType.Aad,
            time: item.time
        }))
    }

    const handlePlay = async (id) => {
        setIsLoading(true)

        try {
            const data = await getCarouselReports(id)

            setIntervalx(setInterval(async () => {
                const newData = await getCarouselReports(id)

                const ids = data.map(item => item.reportId).join("")
                const newIds = newData.map(item => item.reportId).join("")

                if (ids !== newIds) {
                    clearInterval(intervalx)
                    handlePlay(id)
                } else {
                    console.log('refresh')
                    reports.map(report => report.refresh())
                }
            }, 60000))

            setData(data)

            setIntervalz(data[0].time)
        } catch(error) {
            console.log(error)
        } finally {
            setIsLoading(false)
        }
    }

    useEffect(() => {
        (async () => {
            try {
                const { data } = await api.get(`/users-carousels`)

                setCarousels(data)
            } catch(error) {

            }
          })()
    }, [])

    const getData = async (report_id) => {
        try {
            const reportData = await handlePowerBiReportAad({ report_id })
        
            return reportData.accessToken
        } catch(error) {}
    }

    const onChangeFullScreen = (isFullScreen) => {
        setShowCarousel(isFullScreen)
        
        if  (!isFullScreen) {
            setIsLoaded(false)

            clearInterval(intervalx)
        }
    }

    const onChangeCarousel = (_, item) => {
        setIntervalz(item.props["data-interval"])
    }
    
    return (
        <>
        <TitleBar label="Carrosséis" currentPage="" />

        <Content>
            <Card>
                <CardTitle title="Listagem">
                </CardTitle>

                <Table>
                    <thead>
                        <tr>
                            <th width="60">#</th>
                            <th>Nome</th>
                            <th width="100">Ações</th>
                        </tr>
                    </thead>
                    <tbody>
                        {carousels.map(carousel =>
                            <tr key={carousel.id}>
                                <td>{carousel.id}</td>
                                <td>{carousel.users_group.name}</td>

                                <Td>
                                    <BtnOrange style={{ padding: '5px 20px' }} onClick={() => handlePlay(carousel.users_group.id).then(_ =>  handle.enter())}>
                                        <BsFillPlayFill />
                                    </BtnOrange>
                                </Td>
                            </tr>
                        )}
                    </tbody>
                </Table>
            </Card>
        </Content>

        <FullScreen onChange={onChangeFullScreen} handle={handle}>
            {showCarousel && (   
                <Carousel
                    showThumbs={false}
                    stopOnHover={false}
                    showStatus={false}
                    showArrows={false}
                    infiniteLoop={true}
                    showIndicators={false}
                    useKeyboardArrows={false}
                    autoPlay={isLoaded}
                    interval={intervalz}
                    onChange={onChangeCarousel}
                >
                    {data.map((item, index) => (
                        <ItemContainer data-interval={item.time} key={index}>
                            <div id='ReportPageContainer'>
                            <div style={{ visibility: !isLoaded  ? "hidden" : "visible", position: !isLoaded ? "absolute" : "relative" }}>
                            <PowerBIEmbed
                                eventHandlers = {
                                new Map([
                                    ['loaded', () => setIsLoaded(true)],
                                    ['rendered', () => setIsLoaded(true)],
                                    ['error', event => console.log(event.detail)]
                                ])
                                }
                                getEmbeddedComponent={(embedObject) => setReports([...reports, embedObject])}
                                embedConfig={{
                                    type: 'report',
                                    id: item.reportId,
                                    embedUrl: item.embedUrl,
                                    eventHooks: { accessTokenProvider: async () => await getData(item.reportId) },
                                    accessToken: item.token,
                                    tokenType: item.type || models.TokenType.Aad,
                                    settings: {
                                        layoutType: models.LayoutType.Custom,
                                        customLayout: {
                                            displayOption: models.DisplayOption.FitToWidth
                                        },
                                        panes: {
                                            filters: {
                                                visible: item.enable_filters ? item.enable_filters : false
                                            },
                                            pageNavigation: {
                                                visible: item.page_navigation ? item.page_navigation : false
                                            }
                                        }
                                    }
                                }}
                                cssClassName={"personalizedReport"}
                            />
                            </div>

                                {!isLoaded && (
                                    <div id='overlay'>
                                        <img width={80} height={80} id="spinner" alt="Alternate Text" src={"/editor-2.1s-209px.gif"} />
                                    </div>
                                )}
                                </div>
                        </ItemContainer>
                    ))}
                </Carousel>
            )} 
        </FullScreen>

        <LoadingScreen loading={isLoading}  />
    </>
    )
}